import BasicDetail from './BasicDetail';

export default BasicDetail;
